<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>交易管理</el-breadcrumb-item>
            <el-breadcrumb-item>素材管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>

        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input v-model="query.userId" size="small" placeholder="用户id"></el-input>
                <el-input v-model="query.userName" size="small" placeholder="用户名"></el-input>
                <el-select v-model="query.type" size="small" placeholder="素材类型">
                    <el-option label="图片" value="1"/>
                    <el-option label="视频" value="2"/>
                    <el-option label="图片和视频" value="3"/>
                </el-select>
                <el-select v-model="query.status" size="small" placeholder="上传状态">
                    <el-option label="已上传" value="1"/>
                    <el-option label="已采用" value="2"/>
                    <el-option label="已发币" value="3"/>
                    <el-option label="废弃" value="4"/>
                </el-select>
                <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
                <el-button size="small" @click="reset">重置</el-button>
            </el-row>

            <el-table class="cps-table-data"
                      :data="tableData"
                      size="small"
                      border
                      v-loading="loading"
                      element-loading-text="拼命加载中"
                      element-loading-background="#fff"
                      :height="height"
                      style="width: 100%"
                      id="rebateSetTable">
                <el-table-column
                        prop="id"
                        label="素材id"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="user_name"
                        label="用户名"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="user_id"
                        label="用户id"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="type"
                        label="素材类型"
                        :formatter="materialTypeFormat"
                        width="130">
                </el-table-column>
                <el-table-column
                        label="查看图片"
                        width="80">
                    <template slot-scope="scope">
                        <el-image
                                style="width: 50px;height: 50px"
                                src="https://game.7li.cn/static/image/ck.png"
                                v-if = "scope.row.type != 2"
                                :preview-src-list="tableData[scope.$index].srcList">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="videoList"
                        align="center"
                        label="查看视频"
                        width="80">
                    <template slot-scope="scope">
                       <video
                                :src="scope.row.videoList"
                                width="50px"
                                height="50px"
                                v-if="scope.row.type != 1"
                                :class="['imgStyle',{mouse:scope.row.videoList != null && scope.row.videoList.length != 0}]"
                                @click="playVideo(scope.row.videoList)"
                        ></video>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备注"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="wx"
                        label="微信"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="qq"
                        label="QQ"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="上传状态"
                        :formatter="materialStatusFormat"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="abandon_reason"
                        label="废弃理由"
                        :show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="qlb"
                        label="已发币数量"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="add_time"
                        label="上传时间"
                        width="150">
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="employ(scope.row.id)">采用</el-button>
                            <el-button type="text" size="small" @click="sendOutCurrency(scope.row.id)">发币</el-button>
                            <el-button type="text" size="small" @click="abandon(scope.row.id)">废弃</el-button>
                        </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="cps-table-data"
                    @current-change="loadData"
                    background
                    :page-size="10"
                    :current-page="currentIndex"
                    layout="total,prev, pager, next"
                    :total="total">
            </el-pagination>
            <!--视频弹框-->
           <el-dialog
                    :visible.sync="dialogVisible"
                    :width="dialogWidth"
                    :show-close="false"
                    top="13vh"
                    center
                    custom-class="customWidth"
                    @close="closeDialog">
               <div slot="title" class="head">
                <video
                        :src="videoUrl"
                        controls
                        disablePictureInPicture
                        ref="dialogVideo"
                        :width="videoWidth"
                        @canplay="onLoadVideo"
                ></video>
               </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

    import {queryMaterial,employMaterial,sendOutCurrency,abandonMaterial} from "@/api/request"

    export default {
        name: "material",
        data(){
            return{
                tableData:[],
                currentIndex: 1,
                height: window.innerHeight - 220,
                dialogWidth: '',
                videoWidth: '',
                total: 0,
                loading:false,
                videoUrl: '',
                dialogVisible: false,
                query:{
                    userName: '',
                    userId: '',
                    type: '',
                    status: '',
                }
            }
        },
        mounted() {
            this.loadData(this.currentIndex)
        },
        methods:{
            loadData(index){
                this.loading = true;
                let params = {
                    pageNo: index,
                    pageSize: 10,
                    params:this.query
                }
                queryMaterial(params).then( res => {
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                    this.currentIndex = index;
                    this.loading = false;
                })
            },
            playVideo(url){
                if(url.length != 0){
                    this.dialogVisible = true;
                    this.videoUrl = url;
                }
            },
            closeDialog(){
                //清空数据,关闭视频播放
                this.videoUrl = '';
            },
            employ(materialId){
                this.$confirm('确认采用素材吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal:false,
                    type: 'warning'
                }).then(() => {
                    employMaterial(materialId).then(res => {
                        if (res.data.success) {
                            this.loadData(this.currentIndex)
                            this.$message.success("操作成功")
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            abandon(materialId){
                this.$prompt('请输入废弃的理由','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal: false,
                    inputPattern: /^\S/,
                    inputErrorMessage: '理由不能为空!',
                    type: 'warning'
                }).then( ({value}) => {
                    let params = {
                        "id": materialId,
                        "abandonedReason": value
                    }
                    abandonMaterial(params).then( res => {
                        if (res.data.success) {
                            this.loadData(this.currentIndex)
                            this.$message.success("操作成功")
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "取消输入"
                    })
                })
            },
            sendOutCurrency(materialId){
                this.$prompt('请输入发币数量', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[1-9]\d*$/,
                    inputErrorMessage:'请输入整数!',
                    closeOnClickModal:false,
                }).then( ({ value }) => {
                    let param = {
                        "id": materialId,
                        "currencyCount": value
                    }
                    sendOutCurrency(param).then( res => {
                       if(res.data.success){
                           this.loadData(this.currentIndex)
                           this.$message.success("操作成功");
                       } else {
                          this.$message.error(res.data.error.message);
                       }
                   })
                }).catch( () => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            reset(){
                this.query = {
                    userName: '',
                    userId: '',
                    type: '',
                    status: '',
                }
            },
            materialTypeFormat(row, column, cellValue){ //类型 1：图片素材 2：视频素材 3：图片和视频素材
                let str = '';
                if(cellValue === 1){
                    str = '图片'
                }else if (cellValue === 2){
                    str = '视频';
                }else if (cellValue === 3){
                    str = '图片和视频'
                }
                return str;
            },
            materialStatusFormat(row, column, cellValue){ //状态 1：已上传 2：已采用 3：已发币 4：废弃
                let str = '';
                if(cellValue === 1){
                    str = '已上传';
                }else if (cellValue === 2){
                    str = '已采用';
                }else if (cellValue === 3){
                    str = '已发币';
                }else if (cellValue === 4){
                    str = '废弃';
                }
                return str;
            },
            onLoadVideo(e){
                let video = e.target;
                let width = 0;
                if (video.length > 0 || (video.videoWidth > 1 && video.videoHeight > 1)) {
                    width = video.videoWidth;
                }
                if(width > 900){
                    width = 900
                }
                this.videoWidth = width + 45 + 'px';
                this.dialogWidth = width + 'px';
            }
        }
    }
</script>

<style>
    .imgStyle{
        height: 50px;
        width: 50px;
    }
    .mouse{
        cursor: pointer;
    }
    .head{
        margin: -20px -20px -73px -20px;
    }
</style>